import React from 'react';

import CardFiltersProvider from 'components/specific/CardFilters/context/filters-context';
import { CardFiltersContext } from 'components/specific/CardFilters/context/filters-context';
import RatingCard from '../../../components/common/rattingCard/RatingCard';
import CardFilters from 'components/specific/CardFilters';

export const RatingCards = ({
  totalRating,
  setRatingFiter,
  setLocalfiltersRating,
}) => {
  return (
    <CardFiltersProvider>
      <Ratings
        setLocalfiltersRating={setLocalfiltersRating}
        totalRating={totalRating}
        setRatingFiter={setRatingFiter}
      />
    </CardFiltersProvider>
  );
};

function Ratings({ totalRating, setRatingFiter, setLocalfiltersRating }) {
  const { state, dispatch, date } = React.useContext(CardFiltersContext);

  console.log('totalPractopSpecialties', state);

  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  React.useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = {
        ...resultForParent,
        ...formatObject(state),
        local: true,
      };
    });

    setLocalfiltersRating(resultForParent, date.dateState);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);

  return (
    <RatingCard
      totalRating={totalRating}
      setRatingFiter={setRatingFiter}
      state={state}
      dispatch={dispatch}
      date={date}
    />
  );
}
